import React from 'react';
import { Tooltip } from 'antd-v5';
import { Checkbox, InputNumber, Select } from '@/components';
import { FONT_SIZE_OPTIONS } from './thermalPrinterTemplateShared';
import tipIcon from '@/common/images/tip.png';

function ThermalPrinterFieldChip({ meta, value, onChange, hideControls = false }) {
  const field = value || {};
  const checked = meta.required || !!field.printFlag;

  const patch = (next) => {
    onChange({
      ...field,
      ...next,
      fieldName: meta.key,
      ...(meta.required ? { printFlag: true } : {}),
    });
  };

  return (
    <div
      className={`thermalFieldChip ${checked ? 'isChecked' : ''} ${
        meta.required ? 'isRequired' : ''
      }`}
      title={meta.label}
      onClick={() => {
        if (!meta.required) patch({ printFlag: !checked });
      }}
    >
      <Checkbox
        checked={checked}
        disabled={meta.required}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => patch({ printFlag: e.target.checked })}
      />
      <span className='thermalFieldName'>{meta.label}</span>
      {checked && !hideControls ? (
        <span className='thermalFieldControls' onClick={(e) => e.stopPropagation()}>
          <Select
            // size='small'
            className='thermalFontSizeSelect'
            style={{ width: 82 }}
            value={field.fontSize}
            options={FONT_SIZE_OPTIONS}
            onChange={(fontSize) => patch({ fontSize })}
            allowClear={false}
          />
          <ThermalPrinterBoldButton
            checked={!!field.boldFlag}
            onChange={(boldFlag) => patch({ boldFlag })}
          />
        </span>
      ) : null}
    </div>
  );
}

export function ThermalPrinterTextStyleChip({ label, value, onChange }) {
  const field = value || {};
  const patch = (next) => {
    onChange({
      ...field,
      ...next,
    });
  };

  return (
    <div className='thermalFieldChip isChecked isRequired' title={label}>
      <Checkbox checked disabled />
      <span className='thermalFieldName'>{label}</span>
      <span className='thermalFieldControls' onClick={(e) => e.stopPropagation()}>
        <Select
          className='thermalFontSizeSelect'
          style={{ width: 92 }}
          value={field.fontSize}
          options={FONT_SIZE_OPTIONS}
          onChange={(fontSize) => patch({ fontSize })}
          allowClear={false}
        />
        <ThermalPrinterBoldButton
          checked={!!field.boldFlag}
          onChange={(checked) => patch({ boldFlag: checked })}
        />
      </span>
    </div>
  );
}

export function ThermalPrinterToggleChip({ label, checked, onChange, tooltip }) {
  const labelNode = tooltip ? (
    <span className='thermalFieldName thermalFieldNameWithHelp'>
      <span>{label}</span>
      <Tooltip title={tooltip}>
        <img
          src={tipIcon}
          onClick={(e) => e.stopPropagation()}
          alt='tip'
          className='thermalFieldHelpIcon'
        />
      </Tooltip>
    </span>
  ) : (
    <span className='thermalFieldName'>{label}</span>
  );

  return (
    <div
      className={`thermalFieldChip ${checked ? 'isChecked' : ''}`}
      title={tooltip ? undefined : label}
      onClick={() => onChange(!checked)}
    >
      <Checkbox
        checked={checked}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => onChange(e.target.checked)}
      />
      {labelNode}
    </div>
  );
}

export function ThermalPrinterTableHeadEditor({ value, onChange }) {
  const field = value || {};
  const patch = (next) => {
    onChange({
      ...field,
      ...next,
      fieldName: field.fieldName || 'tableHead',
      printFlag: true,
    });
  };
  return (
    <div className='thermalFieldChip isChecked isRequired thermalTableHeadChip' title='表头样式'>
      <Checkbox checked disabled />
      <span className='thermalFieldName'>表头样式</span>
      <span className='thermalFieldControls' onClick={(e) => e.stopPropagation()}>
        <Select
          className='thermalFontSizeSelect'
          style={{ width: 92 }}
          value={field.fontSize}
          options={FONT_SIZE_OPTIONS}
          onChange={(fontSize) => patch({ fontSize })}
          allowClear={false}
        />
        <ThermalPrinterBoldButton
          checked={!!field.boldFlag}
          onChange={(checked) => patch({ boldFlag: checked })}
        />
      </span>
    </div>
  );
}

export function ThermalPrinterBoldButton({ checked, onChange }) {
  return (
    <button
      type='button'
      className={`thermalBoldButton ${checked ? 'isActive' : ''}`}
      title='加粗'
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onChange(!checked);
      }}
    >
      B
    </button>
  );
}

export function ThermalPrinterNumberInput({ value, min = 1, max = 10, onChange }) {
  return (
    <InputNumber
      min={min}
      max={max}
      precision={0}
      value={value}
      onChange={(next) => {
        const num = Number(next);
        if (!Number.isFinite(num)) {
          onChange(min);
          return;
        }
        onChange(Math.min(max, Math.max(min, Math.round(num))));
      }}
      style={{ width: 80 }}
    />
  );
}

export default ThermalPrinterFieldChip;
